import { api } from "../../http";

async function GetDataAllLayout() {
  try {
    
    const data = await api.get(`/layout`);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetDataAllLayout };
